














import {Component, Prop, Watch} from "vue-property-decorator";
import {Locale} from "@/enums/Locale";
import {InputType} from "@/enums/InputType";
import months from "@/data/months";
import {Option} from "@/util/Option";
import {extend} from 'vee-validate';
import {integer} from 'vee-validate/dist/rules';
import FormGroup from "@/components/Form/InputComponents/FormGroup.vue";
import FormInput from "@/components/Form/InputComponents/FormInput.vue";
import Validatable from "@/components/Validatable.vue";
import FormSelect from "@/components/Form/InputComponents/FormSelect.vue";
import {User} from "@/util/User";
import {namespace} from "vuex-class";
import {Store} from "@/enums/Store";
import {Currency} from "@/enums/Currency";

const APP = namespace(Store.APP);

@Component({
  components: {FormSelect, FormInput, FormGroup}
})
export default class AddressForm extends Validatable {
  @Prop({required: true}) member!: User;
  @APP.State('storeId') storeId!: number;
  @APP.State('currency') currency!: Currency;
  @Watch('member', {deep: true})
  updateMember() {
    this.$emit('update:member', this.member)
  }

  TEXT = InputType.TEXT;
  NUMBER = InputType.NUMBER;

  countries!: Option[];
  days: Option[] = [];
  months: Option[] = [];
  years: Option[] = [];
  targetGroup: Option[] = [];
  kFiveStatus: Option[] = [];
  isGermany = false

  created(): void {
    if (this.storeId == 1){
      this.isGermany = true
    }

    extend('integer', {
      ...integer,
      message: this.$t('integer-invalid').toString()
    });

    if (this.storeId == 2){
      this.countries = [
        new Option(this.$t('switzerland').toString(), Locale.CH),
      ];
    }else{
      this.countries = [
        new Option(this.$t('germany').toString(), Locale.DE),
        new Option(this.$t('austria').toString(), Locale.AT),
        new Option(this.$t('switzerland').toString(), Locale.CH),
      ];
    }

    this.targetGroup = [
      new Option('Ich bin ein K5 Standorttrainer*', 'Ich bin ein K5 Standorttrainer*'),
      new Option('Ich bin ein K5 Standortmanager* ', 'Ich bin ein K5 Standortmanager*'),
      new Option('Nachwuchsleiter / Sonstige', 'Nachwuchsleiter'),
      new Option('Hauskreis- bzw. Kleingruppenleiter', 'Hauskreis- bzw. Kleingruppenleiter'),
      new Option('Teamleiter, Bereichsleiter (in Gemeinde oder Beruf)', 'Teamleiter, Bereichsleiter (in Gemeinde oder Beruf)'),
      new Option('Jugendleiter und Junge Generation', 'Jugendleiter und Junge Generation'),
      new Option('Pastor, Gemeindeleiter (Hauptberuflich)', 'Pastor, Gemeindeleiter (Hauptberuflich)'),
      new Option('Unternehmer, Selbstständiger, Führungskraft aus der Wirtschaft', 'Unternehmer, Selbstständiger, Führungskraft aus der Wirtschaft'),
    ]

    this.kFiveStatus = [
      new Option('Ich bin neu beim K5-Leitertraining', 'Ich bin neu beim K5-Leitertraining'),
      new Option('Ich war schon mal bei ein paar Trainingstagen des K5 Leitertrainings dabei', 'Ich war schon mal bei ein paar Trainingstagen des K5 Leitertrainings dabei'),
      new Option('Ich habe in der Vergangenheit bereits 12 Trainingstage des K5 Leitertrainings absolviert', 'Ich habe in der Vergangenheit bereits 12 Trainingstage des K5 Leitertrainings absolviert')
    ]
  }
}
